/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { trackDownload } from 'utils/general';

function DownloadModule(props) {
  return (
    <div className="c-download-module no-print">
      <div className="row">
        <div className="column small-12 medium-6">
          <div className="content">
            <h3 className="-module-title">{props.title}</h3>
            <p className="description">{props.description}</p>
            {props.isDownload ?
              <a
                className="btn -big -blue download-button"
                onClick={trackDownload}
                href={props.link}
              >
                Download
              </a> :
              props.onDownload ?
                <a className="btn -big -blue download-button" onClick={props.onDownload}>
              {props.buttonText}
                </a> :
                <a className="btn -big -blue download-button" href={props.buttonUrl}>
                {props.buttonText}
                </a>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

DownloadModule.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  isDownload: PropTypes.bool,
  onDownload: PropTypes.func
};

DownloadModule.defaultProps = {
  title: 'Download',
  description: 'Access the underlying data, justifications and documentation used to construct the Resource Governance Index.',
  buttonText: 'Got to report',
  buttonUrl: '/publications-data/global-report'
};

export default DownloadModule;



// WEBPACK FOOTER //
// ./app/components/common/DownloadModule.jsx